/* eslint-disable prettier/prettier */
import { useContext, useEffect, useState } from 'react';
import { FiltersContext } from '../FiltersContext';

interface ISelectedBranch {
  id: number;
  name: string;
}

export const useBranchFilters = () => {
  const { setFilterTags } = useContext(FiltersContext);

  const branchOptions = [
    { id: 0, name: 'Selecione uma filial' },
    { id: 101, name: '101 - Extrema - MG' },
    { id: 40, name: '40 - Jandira - SP' }
  ];

  const [selectedBranch, setSelectedBranch] = useState({ id: 0, name: 'Selecione uma filial' });

  const handleChangeSelectedBranch = (choice: ISelectedBranch) => {
    setSelectedBranch(choice);
  };

  const setBranchFilterTag = () => {
    setFilterTags((prev) =>
      prev.map((tag) => {
        if (tag.filterName === 'branchId' && selectedBranch.id !== 0) {
          return { ...tag, value: selectedBranch.name };
        }

        return tag;
      })
    );
  };

  const clearBranchFilters = () => {
    return { id: 0, name: 'Selecione uma filial' };
  };

  useEffect(() => {
    setBranchFilterTag();
  }, [selectedBranch]);

  return { branchOptions, selectedBranch, handleChangeSelectedBranch, clearBranchFilters };
};
